function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "alert",
  transform: "translate(153 214.171)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1282",
  transform: "translate(-153 -214.171)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1976",
  d: "M119.5,102.756,76.391,23.51a17.878,17.878,0,0,0-30.746,0L2.538,102.756a17.868,17.868,0,0,0,15.369,27h86.22A17.871,17.871,0,0,0,119.5,102.756Zm-58.482,12.7a7.151,7.151,0,1,1,7.151-7.151A7.16,7.16,0,0,1,61.018,115.458Zm7.151-28.6a7.151,7.151,0,0,1-14.3,0V51.1a7.151,7.151,0,0,1,14.3,0Z",
  transform: "translate(0 -14.759)",
  fill: "#fd3d40"
})));

var SvgAlert = function SvgAlert(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122.036,
    height: 115,
    viewBox: "0 0 122.036 115",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alert.9f6b5489.svg";
export { ForwardRef as ReactComponent };